import { classNames } from '../../utils/style-class.utils';
export var dropdownWrapper = 'font-body mt-1 inline-flex items-center justify-between origin-top-right right-0 w-full rounded-md font-medium hover:bg-gray-50 focus:border-secondary focus:ring-1 focus:ring-secondary';
export var dropdownClearWrapper = 'font-body mt-1 inline-flex items-center justify-between origin-top-right right-0 w-full rounded-md font-medium hover:bg-gray-50 focus:border-secondary focus:ring-1 focus:ring-secondary';
export var menu = 'relative inline-block text-left w-full';
export var icon = 'h-6 w-6 pr-2 text-white';
export var iconClear = 'h-6 w-6 mr-2 text-uiMid';
export var title = 'px-3 pt-2 pb-2 relative flex';
export var menuItems = 'absolute z-50 mt-1 w-full bg-white max-h-48 rounded-md py-1 text-base overflow-auto border border-tertiaryAccent2 focus:border-uiMidDark focus:ring-uiMidDark focus:ring-1';
export var menuItem = 'block p-2 text-textMid font-h2 cursor-pointer hover:bg-secondary hover:text-white';
export var menuItemSm = 'block px-4 py-2 text-textMid font-h1 text-sm cursor-pointer';
export var menuItemSelected = 'font-h1 block px-4 py-2 cursor-pointer text-textDark';
export var menuItemWrapper = '';
export var enter = 'transition ease-out duration-100';
export var enterFrom = 'transform opacity-0 scale-95';
export var enterTo = 'transform opacity-100 scale-100';
export var leave = 'transition ease-in duration-75';
export var leaveFrom = 'transform opacity-100 scale-100';
export var leaveTo = 'transform opacity-0 scale-95';
export var label = 'font-semibold block text-base font-body leading-snug text-textDark';
export var adminPortalLabel = 'block text-lg font-medium text-gray-800"';
export var subLabel = 'block text-base font-body leading-snug text-textMid self-stretch';
export var getDropDownFill = function (fillType, fillColor) {
    switch (fillType) {
        case 'outlined':
            return classNames('', "border-2 rounded-md border-".concat(fillColor));
        case 'clear':
            return classNames(dropdownClearWrapper, "bg-".concat(fillColor));
        case 'filled':
        default:
            return classNames(dropdownWrapper, "bg-".concat(fillColor));
    }
};
export var getDropDownSelectedTextColour = function (fillType) {
    switch (fillType) {
        case 'clear':
            return 'text-primary';
        case 'filled':
        default:
            return 'text-white';
    }
};
export var getDropDownIcon = function (fillType, colour) {
    switch (fillType) {
        case 'clear':
            return classNames(iconClear, "text-".concat(colour));
        case 'filled':
        default:
            return classNames(icon, "text-".concat(colour));
    }
};
//# sourceMappingURL=dropdown.styles.js.map